<template>
  <div id="header">
    <div class="header_box">
      <div class="header_left lf">
        <router-link :to = "{ name: 'Home' }">
          <img src="../../assets/img/logo.png" alt="logo图片">
        </router-link>
      </div>
      <div class="header_content lf">
        <ul class="header_menu">
          <li class="header_menu_item"><router-link :to = "{ name: 'Home' }">首页</router-link></li>
          <li class="header_menu_item"><router-link :to = "{ name: 'Community' }">社区生态</router-link></li>
          <li class="header_menu_item"><router-link :to = "{ name: 'UnionNav' }">联盟生态</router-link></li>
          <li class="header_menu_item"><router-link :to = "{ name: 'ResearchNav' }">研究院生态</router-link></li>
        </ul>
       <!-- <ul class="header_menu">
          <li class="header_menu_item"><router-link :to = "{ name: 'Home' }">首页</router-link></li>
          <li class="header_menu_item"><router-link :to = "{ name: 'Community' }">社区生态</router-link></li>
          <li class="header_menu_item">
            <el-dropdown trigger="hover" placement="bottom" @command="listJump">
              <router-link class="el-dropdown-link" :to = "{ name: 'Union' }">联盟生态</router-link>
              <el-dropdown-menu slot="dropdown" class="header_-dropdown_menu">
                <el-dropdown-item command="ConciseList">推荐</el-dropdown-item>
                <el-dropdown-item command="DiscussList">研讨沙龙</el-dropdown-item>
                <el-dropdown-item command="TrainList">培训</el-dropdown-item>
                <el-dropdown-item command="ContactsList">企业</el-dropdown-item>
                <el-dropdown-item command="RoadshowList">项目路演</el-dropdown-item>
                <el-dropdown-item command="ForumList">论坛</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="header_menu_item">
            <el-dropdown trigger="hover" placement="bottom" @command="listJump">
              <router-link class="el-dropdown-link" :to = "{ name: 'Research' }">研究院生态</router-link>
              <el-dropdown-menu slot="dropdown" class="header_-dropdown_menu">
                <el-dropdown-item command="ResearchList">研究学院</el-dropdown-item>
                <el-dropdown-item command="FindingsList">研究成果</el-dropdown-item>
                <el-dropdown-item command="IndustryList">行业手册</el-dropdown-item>
                <el-dropdown-item command="ReportList">报告下载</el-dropdown-item>
                <el-dropdown-item command="BookList">书籍</el-dropdown-item>
                <el-dropdown-item command="LearningList">学术交流</el-dropdown-item>
                <el-dropdown-item command="ScholarList">专家学者</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul> -->
      </div>
      <div class="header_right lf">
        <div v-if="watchUser === null" class="header_right_top_login">
          <router-link :to="{ name: 'Login' }">登录</router-link>
          <el-divider class="header_right_vertical" direction="vertical"></el-divider>
          <router-link :to="{ name: 'Register' }">加入绿盟</router-link>
        </div>
        <ul v-else class="header_right_top_user">
          <li class='header_user'>
            <el-popover placement="bottom" width="104" popper-class="user_info_popper" trigger="click" v-model="visible">
              <div class="header_user_info_list">
                <p><router-link @click.native="editPersonalMeunAct" :to="{ name: 'LiveList' }">个人中心</router-link></p>
                <p><a @click="exit">退出</a></p>
              </div>
              <a slot="reference">
                <img :src="watchUser.portrait">
                <span>{{watchUser.name}}</span>
              </a>
            </el-popover>
          </li>
          <li>
            <router-link :to = "{ name: 'Im' }">
              <el-badge class="item" :value="unreadMes" :max="99">
                <i class="el-icon-chat-dot-square"></i>
              </el-badge>
            </router-link>
          </li>
          <li>
            <el-popover placement="bottom" width="300" v-model="onOff" @show="getInformationReadList">
              <ul class="small_bell_list"
              v-infinite-scroll="getInformationReadList"
              :infinite-scroll-disabled="smallBellListOnOff"
              @mouseenter="removeScroll"
              @mouseleave="addScroll">
                <li v-for="(item, index) in smallBellList" :key="item.id" class="small_bell_item">
                  <div class="small_bell_item_top">
                    <p v-if="item.type === 1">
                      <span @click="userJump(item.user_id)">{{item.user_name}}</span> 关注了我</p>
                    <p v-if="item.type === 2">
                      <span  @click="userJump(item.user_id)">{{item.user_name}}</span> 收藏了</p>
                    <p v-if="item.type === 3">
                      <span  @click="userJump(item.user_id)">{{item.user_name}}</span> 点赞了</p>
                    <p v-if="item.type === 4">
                      <span  @click="userJump(item.user_id)">{{item.user_name}}</span> 点赞了您的评论</p>
                    <p v-if="item.type === 5">
                      <span  @click="userJump(item.user_id)">{{item.user_name}}</span> 评论了您发布的
                    </p>
                    <p v-if="item.type === 6">
                      <span  @click="userJump(item.user_id)">{{item.user_name}}</span> 回复了您的评论
                    </p>
                    <p v-if="item.type === 8">
                      <span></span> 系统通知
                    </p>
                    <p v-if="item.type === 9">
                      <span></span> 系统通知
                    </p>
                  </div>
                  <div v-if="item.type === 1" class="">
                  </div>
                  <div v-else-if="item.type === 8" class="small_bell_item_title">
                    {{item.title}}
                  </div>
                  <div v-else-if="item.type === 9" class="small_bell_item_title">
                    {{item.title}} <br>
                    <a>{{item.data.title}}</a>
                  </div>
                  <div v-else class="small_bell_item_title" @click="jump(item.data.list_id, item.data.nav_id)">
                     <a>{{item.data.title}}</a>
                  </div>
                  <div class="small_bell_item_time">
                     {{item.add_time}}
                  </div>
                  <div v-if="index === smallBellList.length-1">
                    <p class="small_bell_tip" v-if="smallBellLoad">加载中...</p>
                    <p class="small_bell_tip" v-if="noMore">没有更多了</p>
                  </div>
                </li>
              </ul>
              <div style="text-align: right; margin-top: 5px">
                <el-button type="primary" size="mini" @click="smallBellAll">查看全部</el-button>
              </div>
              <a slot="reference">
                <el-badge :value="smallBellCount" :max="99" class="item">
                  <i class="el-icon-bell"></i>
                </el-badge>
              </a>
            </el-popover>
          </li>
        </ul>
        <div class="header_right_bottom">
          <el-input type="text" size="medium" placeholder="请输入内容" suffix-icon="iconfont icon-search"
          v-model="searchData" @keyup.enter.native="getSearch"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      loginState: false,
      activeIndex: 1, // 导航栏选中
      user: null,
      onOff: false, // 小铃铛显示开关
      visible: false, // 个人中心下拉菜单显示开关
      smallBellList: [],
      smallBellListPage: {
        limit: 10,
        page: 1
      },
      smallBellListOnOff: false,
      smallBellLoad: false,
      noMore: false,
      searchData: ''
    }
  },
  created () {
    this.imNum = this.$store.state.other.unreadMessage
  },
  computed: {
    watchUser: function () {
      return this.$store.state.user.info
    },
    smallBellCount: function () {
      return this.$store.state.other.smallBellCount
    },
    unreadMes: function () {
      return this.$store.state.other.unreadMessage
    }
  },
  methods: {
    // 获取小铃铛列表
    getInformationReadList () {
      const vueThat = this
      vueThat.smallBellLoad = true
      if (vueThat.smallBellCount > 0) {
        vueThat.smallBellListPage.page = 1
      } else {
        if (vueThat.smallBellList.length === 0) {
          vueThat.smallBellListPage.page = 1
        } else {
          vueThat.smallBellListPage.page++
        }
      }
      vueThat.myApi.getInformationReadList(vueThat.smallBellListPage).then((res) => {
        vueThat.smallBellLoad = false
        if (res.data.code === 200) {
          if (res.data.data.data.length === 0) {
            vueThat.smallBellListOnOff = true
            vueThat.noMore = true
          } else {
            vueThat.smallBellList.push(...res.data.data.data)
          }
          this.clearInformationRead() // 清除小铃铛数量
        }
      })
    },
    // 清除小铃铛阅读数
    clearInformationRead () {
      this.$store.state.other.smallBellCount = 0
      this.myApi.clearInformationRead()
    },
    // 禁止滚动
    removeScroll () {
      this.mycommon.RemoveScroll()
    },
    // 允许滚动
    addScroll () {
      this.mycommon.AddScroll()
    },
    listJump (url) {
      this.$router.push({ name: url })
    },
    // 页面跳转
    jump (rid, navId) {
      this.mycommon.detailJump(this, rid, navId)
    },
    // 查看全部
    smallBellAll () {
      this.onOff = false
      this.$store.commit('editPersonalMeunAct', 'aboutDynamic')
      this.$router.push({ name: 'AboutDynamic' })
    },
    // 搜索回车键
    getSearch () {
      const routeData = this.$router.resolve({
        path: '/searchList/:val',
        query: { val: this.searchData }
      })
      window.open(routeData.href, '_blank')
    },
    // 修改个人中心导航栏默认打开的子菜单
    editPersonalMeunAct () {
      this.visible = false
      this.$store.commit('editPersonalMeunAct', 'liveList')
    },
    // 退出操作
    exit () {
      const vueThat = this
      vueThat.visible = false
      // 退出登录
      vueThat.myApi.loginOut().then(res => {
        vueThat.onLogin()
        const promise = vueThat.webIM.logout()
        if (promise !== undefined) {
          promise.then(function (res) {
          }).catch(function (erro) {
            console.log(erro)
          })
        }
        vueThat.$alert('您已成功退出', '温馨提示', {
          showConfirmButton: true,
          iconClass: 'iconfont icon-icon_richeng_btn_pass',
          callback: action => {
            vueThat.$router.push({ path: '/' })
          }
        })
        localStorage.removeItem('user')
        vueThat.$store.state.user.info = null
      })
    },
    // 登陆
    onLogin () {
      const vueThat = this
      const promise = vueThat.webIM.login({ userID: vueThat.watchUser.id + '', userSig: vueThat.watchUser.sig })
      promise.then(function (imResponse) {
        // 登陆成功
        vueThat.imLoading.loading = false
        if (imResponse.data.repeatLogin === true) {
          // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
        }
      }).catch(function (imError) {
      })
    },
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
</style>
